function MailFooter() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <path
        d="M14.2694 2.7998H2.73078C1.77539 2.7998 1 3.57487 1 4.52985V11.45C1 12.405 1.77539 13.1801 2.73078 13.1801H14.2694C15.2248 13.1801 16.0002 12.405 16.0002 11.45V4.52985C16.0002 3.57487 15.2248 2.7998 14.2694 2.7998ZM11.0784 7.9248L14.7742 11.7073L10.2661 8.48822L8.50008 9.63756L6.73294 8.48764L2.22539 11.7066L5.92179 7.92422L1.45231 4.4422L8.50008 8.2414L15.5473 4.4422L11.0784 7.9248Z"
        fill="#5D6977"
      />
    </svg>
  );
}

export default MailFooter;
